import {Message} from "@twilio/conversations";
import {Box} from "@mui/material";

import {Colors, Container, Text} from "@bounce/shared/ui";
import {getDaysOld} from "../utils/getDaysOld";
import {SeparatorType} from "./definitions";

export const MessageListSeparator = ({message, separatorType}: {message: Message; separatorType: SeparatorType}) => {
  const isNew = separatorType === "new";
  const lineColor = isNew ? Colors.red._800 : Colors.grey._300;
  const textColor = isNew ? Colors.red._800 : Colors.grey._900;

  const getSeparatorText = () => {
    if (isNew) {
      return "New";
    }
    // @ts-ignore
    const daysOld = getDaysOld(message.dateCreated);
    if (daysOld === 0) {
      return "Today";
    }
    if (daysOld === 1) {
      return "Yesterday";
    }
    return message.dateCreated?.toLocaleDateString();
  };

  return (
    <Container
      row
      fullWidth
      sx={{justifyContent: "space-between", mt: "8px", mb: "16px", gap: 0}}
      data-test="new-message-separator"
      // @ts-expect-error - Container doesn't expose role
      role="separator"
    >
      <Box sx={{flex: 1, borderTop: `2px solid ${lineColor}`}} aria-hidden="true" />
      <Text size={12} color={textColor} sx={{mx: "12px"}}>
        {getSeparatorText()}
      </Text>
      <Box sx={{flex: 1, borderTop: `2px solid ${lineColor}`}} aria-hidden="true" />
    </Container>
  );
};
